// Shared server-side pagination defaults for the Results tables (global +
// patient). The page size doubles as the request `limit`.
export const DEFAULT_ROWS_PER_PAGE = 20;

export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
